module.exports = __webpack_public_path__ + "img/recording.afbcd152.webp";